// -*- mode: js; js-indent-level: 2; -*-

import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/home/Home'
import Contact from '@/components/Come'
import Taproom from '@/components/taproom/Taproom'
import Brewery from '@/components/brewery/Brewery'
import Visit from '@/components/brewery/Visit'
import Kegs from '@/components/brewery/Kegs'
import BeerDetail from '@/components/beers/BeerDetail'
import ItemDetail from '@/components/beers/ItemDetail'
import BeerList from '@/components/beers/BeerList'
import DealerList from '@/components/dealers/DealerList'

Vue.use(Router)

export default new Router({
  mode: 'history',
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      // Attendre que le DOM soit prêt
      return new Promise((resolve) => {
        setTimeout(() => {
          const element = document.querySelector(to.hash)
          if (element) {
            const menubarHeight = window.innerHeight * 0.08 // 8vh
            const elementPosition = element.getBoundingClientRect().top + window.pageYOffset
            const offsetPosition = elementPosition - menubarHeight - 20 // 20px d'espace supplémentaire
            
            window.scrollTo({
              top: offsetPosition,
              behavior: 'smooth'
            })
          }
          resolve()
        }, 100)
      })
    }
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
  routes: [
    {
      name: 'home',
      path: '/',
      component: Home
    },
    {
      name: 'contact',
      path: '/contact',
      component: Contact
    },
    {
      path: '/taproom',
      name: 'taproom',
      components: {
        'default': Taproom
      }
    },
    {
      path: '/brewery',
      name: 'brewery',
      components: {
        'default': Brewery
      }
    },
    {
      path: '/brewery/visit',
      name: 'brewery/visit',
      components: {
        'default': Visit
      }
    },
    {
      path: '/brewery/kegs',
      name: 'brewery/kegs',
      components: {
        'default': Kegs
      }
    },
    {
      path: '/dealers',
      name: 'dealers',
      components: {
        'default': DealerList
      }
    },
    {
      path: '/b',
      name: 'beer-list',
      components: {
        'default': BeerList
      }
    },
    {
      path: '/i/:slug',
      name: 'item-detail',
      components: {
        'default': ItemDetail
      }
    },
    {
      path: '/b/:slug',
      name: 'beer-detail',
      components: {
        'default': BeerDetail
      }
    }
  ]
})
